function initializeBundleModalObserver()
{
 
    const targetNode = document.querySelector('.ReactModalPortal');
    if (!targetNode) { 
        setTimeout(initializeBundleModalObserver, 100);  
        return;
    }

    const config = { childList: true, subtree: true };
    let elementAdded = false;

    const callback = function(mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(node => {
                    if (!elementAdded) {
                        console.log('footer found');
                        const appendedTextExist = document.querySelector('.appended-text');
                        if(!appendedTextExist)
                        {
                          const appendedText = document.createElement('p');
                          appendedText.textContent =bundle_text_under_price;
                          appendedText.classList.add('appended-text');
  
                          const elements = document.querySelectorAll('.bundle-builder-app--bundle--summary .bundle-builder-app--bundle--price');
                          elements.forEach(element => {
                              element.prepend(appendedText);
                          });
                        } 
                        const titles = document.querySelectorAll('.bundle-builder-app--bundle--contents-name');
 
                        let maxHeight = 0; 
                        titles.forEach(element => {
                        const height = element.clientHeight;
                         if (height > maxHeight) {
                                  maxHeight = height;
                              }
                          }); 
                          titles.forEach(element => {
                              element.style.height = maxHeight + 'px';
                          }); 
                        elementAdded = true;
                    }
                });

                mutation.removedNodes.forEach(node => {
                    console.log('element removed');
                    elementAdded = false;
                });
            }
        }
        };

        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
}